export default "/images/topdanmark-logo-150-2021.webp?158d093b502f8f1388d79c2c0ad2a15a";